import React, { Component } from 'react'
import { connect } from 'react-redux'
import querystring from 'querystring'

import fetchApi from '../../../services/fetchApi'
import Alert from 'react-s-alert'
import {
  selectMenu,
  fetchGroups,
  changeView,
  fetchAllPatientsInGroup,
} from '../../../state/actions/patient-groups'
import EditView from './View'

class EditViewContainer extends Component {
  constructor(props) {
    super(props)
    const { group } = this.props
    this.state = {
      id: group ? group.id : null,
      name: group ? group.name : '',
      description: group ? group.description : '',
      search: '',
      searchResults: [],
      patientsToAdd: new Map(),
      patientsToRemove: new Map(),
      membersToDisplay: new Map(),
    }
  }

  componentDidMount() {
    const { id } = this.state
    if (id) {
      this.props.fetchAllPatients(id)
    }
  }

  componentWillReceiveProps(nextProps) {
    const { group, patients } = nextProps
    if (!group) {
      this.resetState()
    } else if (nextProps.patients !== this.props.patients) {
      this.setState({
        membersToDisplay: this.selectMembersToDisplay(
          this.state.patientsToAdd,
          this.state.patientsToRemove,
        ),
      })
    }
  }

  onInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  resetState = () => {
    this.setState({
      id: null,
      name: '',
      description: '',
      search: '',
      searchResults: [],
      patientsToAdd: new Map(),
      patientsToRemove: new Map(),
      membersToDisplay: new Map(),
    })
  }

  getPatientsFromSearch = () => {
    if (this.state.search) {
      const params = querystring.stringify({ search: this.state.search })

      fetchApi(`/patients?${params}`)
        .then((res) => {
          this.setState({
            searchResults: res.patients,
          })
        })
        .catch((err) => {
          console.error(err)
        })
    } else {
      this.setState({
        searchResults: [],
      })
    }
  }

  selectMembersToDisplay = (patientsToAdd, patientsToRemove) => {
    const members = this.props.patients
      .filter(
        patient =>
          !patientsToAdd.has(patient.id) && !patientsToRemove.has(patient.id),
      )
      .concat(Array.from(patientsToAdd.values()))

    return new Map(members.map(m => [m.id, m]))
  }

  filterSearchResults = () =>
    this.state.searchResults.filter(
      patient => !this.state.membersToDisplay.has(patient.id),
    )

  addOrRemovePatient = (patient, addTo, removeFrom) => {
    const newAddTo = new Map(addTo.entries())
    const newRemoveFrom = new Map(removeFrom.entries())
    if (removeFrom.has(patient.id)) {
      newRemoveFrom.delete(patient.id)
    }
    newAddTo.set(patient.id, patient)
    return {
      newAddTo,
      newRemoveFrom,
    }
  }

  addPatientsToGroup = (patient) => {
    const { newAddTo, newRemoveFrom } = this.addOrRemovePatient(
      patient,
      this.state.patientsToAdd,
      this.state.patientsToRemove,
    )
    this.setState({
      patientsToAdd: newAddTo,
      patientsToRemove: newRemoveFrom,
      membersToDisplay: this.selectMembersToDisplay(newAddTo, newRemoveFrom),
    })
  }

  removePatientsFromGroup = (patient) => {
    const { newAddTo, newRemoveFrom } = this.addOrRemovePatient(
      patient,
      this.state.patientsToRemove,
      this.state.patientsToAdd,
    )
    this.setState({
      patientsToAdd: newRemoveFrom,
      patientsToRemove: newAddTo,
      membersToDisplay: this.selectMembersToDisplay(newRemoveFrom, newAddTo),
    })
  }

  onCancel = () => {
    if (this.state.id) {
      this.props.changeToListView()
    } else {
      this.resetState()
    }
  }

  onSubmit = () => {
    const createOrUpdateRequest = this.state.id
      ? this.updateGroup
      : this.createGroup

    createOrUpdateRequest().then((res) => {
      this.props.onFinish(res.group.id, 'groups')
    })
  }

  createGroup = () => fetchApi('/patients/groups', 'POST', {
    body: JSON.stringify({
      name: this.state.name,
      description: this.state.description,
      patient_ids_to_add: Array.from(this.state.patientsToAdd.keys()),
    }),
  })

  deleteGroup = () => {
    fetchApi(`/patients/groups/${this.state.id}`, 'DELETE')
      .then(() => {
        Alert.success('group deleted')
        this.props.onFinish('today', 'filters')
      })
      .catch(() => {
        Alert.error('unable to delete group')
        this.props.onFinish('today', 'filters')
      })
  }

  updateGroup = () =>
    fetchApi(`/patients/groups/${this.state.id}`, 'PATCH', {
      body: JSON.stringify({
        name: this.state.name,
        description: this.state.description,
        patient_ids_to_add: Array.from(this.state.patientsToAdd.keys()),
        patient_ids_to_remove: Array.from(this.state.patientsToRemove.keys()),
      }),
    })

  render() {
    const { group } = this.props
    return (
      <EditView
        addToGroup={this.addPatientsToGroup}
        onDelete={this.deleteGroup}
        description={this.state.description}
        handleSearchParams={this.getPatientsFromSearch}
        isEdit={!!group}
        membersToDisplay={Array.from(this.state.membersToDisplay.values())}
        name={this.state.name}
        onChange={this.onInputChange}
        onSubmit={this.onSubmit}
        onCancel={this.onCancel}
        removeFromGroup={this.removePatientsFromGroup}
        searchValue={this.state.search}
        searchResults={this.filterSearchResults()}
      />
    )
  }
}

const mapStateToProps = ({ patientGroups }) => {
  const { selectedMenu, patients, groups } = patientGroups
  return {
    patients,
    group: groups.find(group => group.id === selectedMenu.id),
  }
}

const mapDispatchToProps = dispatch => ({
  changeToListView: () => {
    dispatch(changeView('list'))
  },
  onFinish: (id, menuType) => {
    dispatch(fetchGroups()).then(() => {
      dispatch(selectMenu(id, menuType, 'list'))
    })
  },
  fetchAllPatients: (id) => {
    dispatch(fetchAllPatientsInGroup(id))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(EditViewContainer)



// WEBPACK FOOTER //
// ./src/components/PatientGroups/Edit/index.js